import { useEffect } from "react";
import { FieldValues, SubmitHandler, useForm } from "react-hook-form"
import { useChangePasswordMutation } from "../../../../../API/authApi";
import { IChangePasswordData } from "../../../../../Interfaces/request-interfaces";
import { IErrorResponse } from "../../../../../Interfaces/responseTypes";
import { useToastify } from "../../../../../Hooks/hooks";
import useLanguagesHooks from "../../../../Languages/setLanguage-hooks";

const useChangePasswordHooks = (onClose: () => void) => {
    const { register, handleSubmit, formState: { errors }, reset, setError } = useForm<IChangePasswordData>();
    const [changePassword, { isSuccess, isLoading, isError, error }] = useChangePasswordMutation();
    const { showToastSuccess } = useToastify();
    const {t} = useLanguagesHooks();

    useEffect(() => {
        if (isSuccess) {
            onCloseDialog()!;
            showToastSuccess(t('Toast.Success.Common'))
        } else if (isError && (error as IErrorResponse).error === 401) {
            setError('old_password', { message: '' })
        }
    }, [isSuccess, isError, error]);

    const onCloseDialog = () => {
        onClose()!;
        reset();
    };

    const onSubmit: SubmitHandler<IChangePasswordData | FieldValues> = (values) => {
        const payload: IChangePasswordData = {
            old_password: values.old_password,
            new_password: values.new_password
        };
        console.log(payload);
        changePassword(payload)
    };

    return {
        register,
        handleSubmit,
        onSubmit,
        onCloseDialog,
        errors,
        isLoading
    }

};

export default useChangePasswordHooks